import { rest } from "msw";
import { apiUrl } from "features/configure";
import { users } from "./data/MockUsers";

const getCustomerReport = rest.post(
  `${apiUrl}/api/customerReport/:entityName`,
  (req, res, ctx) => {
    const { entityName } = req.params;

    return res(ctx.status(200), ctx.json(users.reports));
  }
);

const getImportHistory = rest.get(
  `${apiUrl}/api/userSource/:entityName/importHistory`,
  (req, res, ctx) => {
    const { entityName } = req.params;

    return res(ctx.status(200), ctx.json(users.history));
  }
);

const getUserBasicInfo = rest.get(
  `${apiUrl}/api/user/:entityName/basicInfo`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),

      ctx.json(users.basicInfo)
    );
  }
);
const getUserOnchainData = rest.get(
  `${apiUrl}/api/user/:entityName/onchainData`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(users.onchainData));
  }
);
const getUserTokenHoldings = rest.post(
  `${apiUrl}/api/user/:entityName/tokenHoldings`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.set("x-total-count", "60"),
      ctx.json(users.tokenHodings)
    );
  }
);

const getUserNFTHoldings = rest.post(
  `${apiUrl}/api/user/:entityName/nftHoldings`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.set("x-total-count", "1"),
      ctx.json(users.nftHoldings)
    );
  }
);

const getUserFilters = rest.get(
  `${apiUrl}/api/user/:entityName/filters`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        cexLabels: [
          "Binance",
          "KuCoin",
          "Luno",
          "Unknown",
          "FTX",
          "Gate.io",
          "OKX",
          "Coinbase",
          "SwissBorg",
          "SimpleSwap",
          "Poloniex",
          "Coinone",
          "Bitget",
          "Bitfinex",
          "Kraken",
          "Bittrex",
        ],
      })
    );
  }
);

const getUserSource = rest.get(
  `${apiUrl}/api/userSource/:entityName`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([
        {
          _id: 1,
          entity: "653893232bd756be9bc2c452",
          indicator: "singleUser",
        },
        {
          _id: 2,
          entity: "653893232bd756be9bc2c452",
          indicator: "websiteTraffic",
        },
        {
          _id: 3,
          entity: "653893232bd756be9bc2c452",
          indicator: "contract",
        },
        {
          _id: 4,
          entity: "653893232bd756be9bc2c452",
          indicator: "metadesk",
        },
        {
          _id: 5,
          entity: "653893232bd756be9bc2c452",
          indicator: "notificationUser",
        },
        {
          _id: 6,
          entity: "653893232bd756be9bc2c452",
          indicator: "attribution",
        },
        {
          _id: 7,
          entity: "653893232bd756be9bc2c452",
          indicator: "csv",
        },
      ])
    );
  }
);

const getUserViews = rest.get(
  `${apiUrl}/api/customerReport/:entityName/views`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json([]));
  }
);

export const customersMocks = [
  getCustomerReport,
  getImportHistory,
  getUserBasicInfo,
  getUserOnchainData,
  getUserTokenHoldings,
  getUserNFTHoldings,
  getUserFilters,
  getUserSource,
  getUserViews,
];
